import { STANDORT_BY_ID } from '@/domain/dienstplan/shared/hooks/useStandort/queries';
import { Standort } from '@/domain/dienstplan/shared/types/Standort';
import {
  Dienstplan_StandortByIdQuery,
  Dienstplan_StandortByIdQueryVariables,
} from '@/gql/graphql';
import { useSuspenseQuery } from '@apollo/client/react';
import * as Sentry from '@sentry/react';

export function useStandort(standortId: string): Standort {
  const result = useSuspenseQuery<
    Dienstplan_StandortByIdQuery,
    Dienstplan_StandortByIdQueryVariables
  >(STANDORT_BY_ID, {
    variables: {
      standortId,
    },
    fetchPolicy: 'no-cache',
  });

  if (result.error) {
    Sentry.captureException(result.error);
  }

  return new Standort({
    tageswechsel: result.data.dienstplan_findStandortById.tageswechsel,
  });
}
